import React from "react";
import './imageBackground.scss';



const ImgBackground = ({ insideText, imgPath }) => {
  const divStyle = {
    backgroundImage: `url(${imgPath})`,
  };

  return (
    <div className="background-img-container" style={divStyle}>
      {insideText}
    </div>
  );
};

export default ImgBackground;
